import { registerSlots, type SlotEntry } from '@saas/ui';
import { conversationSlots } from '@saas/module-conversation/ui';
import { storageSlots } from '@saas/module-storage/ui';
import { relationshipSlots } from '@saas/module-relationship/ui';
import { meetingIngestSlots } from '@saas/module-meeting-ingest/ui';
import { knowledgeSlots } from '@saas/module-knowledge/ui';
import { taskSlots } from '@saas/module-task/ui';
import { crmSlots } from '@saas/module-crm/ui';
import { salesSlots } from '@saas/module-sales/ui';
import { calendarSlots } from '@saas/module-calendar/ui';
import { telephonySlots } from '@saas/module-telephony/ui';
import { invoiceSlots } from '@saas/module-invoice/ui';

/**
 * 画面の差し込み口（@saas/ui の Slot）にモジュールの部品を登録する。組み立て（ここ）だけがホストとプロバイダの両方を知る。
 * 各モジュールは `ui/index.ts` から `<module>Slots: SlotEntry[]` を export する（部品は lazy で読む・初期バンドルを太らせない）。
 * 出すかどうか（モジュールの有効 / 権限）は Slot 側で判定する。
 */
const entries: SlotEntry[] = [
  ...taskSlots,
  // conversation: 「自分宛て」に未読の DM と自分宛てメンション（03 §12.10.3）
  ...conversationSlots,
  // storage: 顧客・商談・案件・契約に結びついたファイル（02 §6）
  ...storageSlots,
  // relationship: 連絡先の詳細に開示請求（contact 単位・事実だけ）の導線（03 §17.9）
  ...relationshipSlots,
  // meeting-ingest: 顧客・商談・案件の最近の会議（03 §13.2）と、期限の近い自分の宿題（§12.10.3）
  ...meetingIngestSlots,
  // knowledge: 文脈サジェスト（form.assist）・レコードについて社内が知っていること（record.panel）・会議後の 1 問（meeting.afterSummary）（03 §14.5・§15.2）
  ...knowledgeSlots,
  // crm: 取引先・連絡先の詳細に「この会社（人）からの問い合わせ・見込み客」（SFA §5.9 逆引き）、
  //      取引先・連絡先・見込み客・商談の詳細に「共有メール」（SFA 1B §6.3・crm.shared-emails。押すと本文ドロワー）
  ...crmSlots,
  // sales: 見込み客の詳細（subject `lead`）に「商談を作成」（record.actions）と「関連商談」（record.panel）（SFA §5.4）、
  //        「追客カード」（record.panel・sales.lead-followups・order 5 = crm の「追客」メモの直後。SFA 1B §7 の Tasuki の追客カード）、
  //        取引先の詳細（subject `customer`）に「追客」（record.panel・sales.customer-followups・order 20。SFA §15.3.3 取引先を出所にした追客カード）、
  //        「更新と受注」（record.panel・sales.customer-renewals・order 25。SFA §15.3.1 次の更新期限・最後の受注・更新商談の候補の数）
  ...salesSlots,
  // calendar: 見込み客の詳細に「日程調整リンクを発行」（record.actions）と、見込み客・取引先の詳細に「日程調整リンク」
  //           （record.panel・order 45。発行済みリンクと予約の一覧・取り消し。SFA §15.5 段階 4 日程調整の公開リンク）
  ...calendarSlots,
  // telephony: 見込み客の詳細に「発信」（record.actions・order 30。SFA 段階 5 §9.4 クリック発信）
  ...telephonySlots,
  // invoice: 案件の詳細に「請求・入金」（record.panel・order 60。請求額・入金額・未回収と最近の帳票。08 §3.4）
  ...invoiceSlots,
];

export function installSlots(): void {
  registerSlots(entries);
}
